import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";

// import PaymentPageProvider from "./contexts/PaymentPageLoader"

import { Link } from "./pages/Payments/Link/Link";
import { CheckoutPix } from "./pages/Payments/CheckoutPix/CheckoutPix";
import Sucesso from "./pages/Payments/Status/Sucesso";
import Falha from "./pages/Payments/Status/Falha";
import Cancelamento from "./pages/Payments/Status/Cancelado";
import Revisao from "./pages/Payments/Status/Revisao";

import NotFound from "./components/notFound/notFound";

// Rota para teste e estudo
import Teste from "./pages/Payments/Teste/Teste"
import Teste2 from "./pages/Payments/Teste2/Teste2"
import Teste3 from "./pages/Payments/Teste3/Teste3"

//contexto para popup
// import ConfirmationPopUp from "./contexts/confirmationPopUp"

function Routes() {
  return (
    <Router>
      {/* <Navbar /> */}
      <Switch>
        {/* <ConfirmationPopUp> */}
        <Route path="/link/:id" exact component={Link} />
        <Route path="/pix" exact component={CheckoutPix} />
        <Route path="/checkout/success" exact component={Sucesso} />
        <Route path="/checkout/cancel" exact component={Cancelamento} />
        <Route path="/checkout/failure" exact component={Falha} />
        <Route path="/checkout/review" exact component={Revisao} />
        {/* </ConfirmationPopUp> */}


        <Route path="/teste" exact component={Teste} />
        <Route path="/teste2" exact component={Teste2} />
        <Route path="/teste3" exact component={Teste3} />

        <Route component={NotFound} />
      </Switch>
      {/* <Footer /> */}
    </Router>
  );
}

export default Routes;
